module.exports = __webpack_public_path__ + "static/media/Textsummary.ad64e899.svg";